import { Cookie } from '@nuxt-common/util/app/utils/cookie';
import { tagBagIconAccuracy } from '#shared/features/analytics/bagTags';
import { isMobileOrTabletDevice } from '~/utils/device';

export default {};

export function useBag() {
  function getBagCountCookie() {
    const sessionValueRaw = Cookie.get('CartItem', 'GCs');
    const persistentValueRaw = Cookie.get('CartItem', 'MISCGCs');

    const hasSession = sessionValueRaw && sessionValueRaw !== 'undefined';
    const hasPersistent = persistentValueRaw && persistentValueRaw !== 'undefined';

    if (!hasSession && hasPersistent) {
      tagBagIconAccuracy();
    }

    let countToUse = sessionValueRaw;

    if (isMobileOrTabletDevice()) {
      countToUse = hasPersistent ? persistentValueRaw : sessionValueRaw;
    }

    return parseInt(countToUse as string, 10) || 0;
  }

  return {
    getBagCountCookie,
  };
}
